import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import axios from "axios";
import store from "../store";
import { setTokenExpired } from "../Redux/authSlice";
import { Loader } from "../components/Loader";
import { getCookie } from "../lib/cookies";
import {
  getCustomerFromMemory,
  setCustomerInMemory,
  setWhitelabelInMemory,
} from "../lib/sharedSessionMemory";

const RECOVERY_TIMEOUT_MS = 2500;

const isAuthPath = () =>
  typeof window !== "undefined" && window.location.pathname.includes("/auth");

const isSessionReadySync = () =>
  isAuthPath() ||
  (typeof window !== "undefined" &&
    (!!getCustomerFromMemory() || !getCookie("wlt")));

export function SessionRecoveryProvider({ children }) {
  const [recoveryReady, setRecoveryReady] = useState(isSessionReadySync);
  const location = useLocation();
  const pathname = location?.pathname || (typeof window !== "undefined" ? window.location.pathname : "");
  const isAuthPage = pathname.includes("/auth");

  useEffect(() => {
    if (isAuthPage) {
      setRecoveryReady(true);
      return;
    }

    let cancelled = false;
    const timeoutId = setTimeout(() => {
      if (!cancelled) setRecoveryReady(true);
    }, RECOVERY_TIMEOUT_MS);

    const runRecovery = async () => {
      try {
        const token = getCookie("wlt");
        const customer = getCustomerFromMemory();

        if (token && customer) {
          if (!cancelled) setRecoveryReady(true);
          return;
        }

        if (token && !customer) {
          let channel = process.env.REACT_APP_DEFAULT_CHANNEL;
          try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            channel = payload?.channel ?? channel;
          } catch (_) {}

          const API_URL_CREDENCIAIS = process.env.REACT_APP_API_AUTHORIZATION + "/v1";
          const { data: authData } = await axios.post(
            `${API_URL_CREDENCIAIS}/jwt/validate-channel`,
            { channel, token }
          );

          if (authData?.success && !cancelled) {
            setCustomerInMemory(authData);
            const whitelabelData =
              authData?.whitelabel ||
              authData?.data?.whitelabel ||
              authData?.data?.config?.whitelabel;
            if (whitelabelData) {
              setWhitelabelInMemory(whitelabelData);
            }
            store.dispatch(setTokenExpired(false));
          } else if (!authData?.success && !cancelled) {
            store.dispatch(setTokenExpired(true));
          }
        }
      } catch (err) {
        console.warn("Recuperação de sessão (ITP):", err?.message || err);
      } finally {
        if (!cancelled) setRecoveryReady(true);
      }
    };

    runRecovery();
    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [isAuthPage]);

  if (!recoveryReady) {
    return <Loader />;
  }

  return <>{children}</>;
}

SessionRecoveryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
